"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MetaField = /** @class */ (function () {
    function MetaField(metaFieldId, displayNameMsgId, //need for MetaCategory Manager
    type, metaFieldTypeStr, isMultiline, //just for debugging
    compoundCategorySystemName, maxLength, fieldPrefix, //if type is compound the system name of compound category
    isSystemField, displayNameMultilingual, isActionDataField, isTransient) {
        this.metaFieldId = metaFieldId;
        this.displayNameMsgId = displayNameMsgId;
        this.type = type;
        this.metaFieldTypeStr = metaFieldTypeStr;
        this.isMultiline = isMultiline;
        this.compoundCategorySystemName = compoundCategorySystemName;
        this.maxLength = maxLength;
        this.fieldPrefix = fieldPrefix;
        this.isSystemField = isSystemField;
        this.displayNameMultilingual = displayNameMultilingual;
        this.isActionDataField = isActionDataField;
        this.isTransient = isTransient;
    }
    MetaField.prototype.getSystemName = function () {
        return this.metaFieldId.getSystemName();
    };
    MetaField.prototype.getMaxLength = function () {
        return this.maxLength;
    };
    MetaField.prototype.getFieldPrefix = function () {
        return this.fieldPrefix;
    };
    MetaField.prototype.setFieldPrefix = function (value) {
        this.fieldPrefix = value;
    };
    MetaField.prototype.getMetaFieldId = function () {
        return this.metaFieldId;
    };
    MetaField.prototype.getDisplayNameMsgId = function () {
        return this.displayNameMsgId;
    };
    MetaField.prototype.getType = function () {
        return this.type;
    };
    MetaField.prototype.getCompoundCategorySystemName = function () {
        return this.compoundCategorySystemName;
    };
    MetaField.prototype.getIsMultiline = function () {
        return this.isMultiline;
    };
    MetaField.prototype.getIsSystemField = function () {
        return this.isSystemField;
    };
    MetaField.prototype.getIsTransient = function () {
        return this.isTransient;
    };
    MetaField.prototype.getDisplayNameMultilingual = function () {
        return this.displayNameMultilingual;
    };
    MetaField.prototype.getIsActionDataField = function () {
        return this.isActionDataField;
    };
    MetaField.prototype.setIsActionDataField = function (value) {
        this.isActionDataField = value;
    };
    MetaField.prototype.toString = function () {
        return "(" + this.metaFieldId.getSystemName() + ","
            + this.displayNameMsgId + ","
            + this.type + ","
            + this.metaFieldTypeStr + ","
            + this.isMultiline +
            +this.compoundCategorySystemName + ")";
    };
    return MetaField;
}());
exports.MetaField = MetaField;
var MetaFieldType;
(function (MetaFieldType) {
    MetaFieldType[MetaFieldType["INTEGER_IDENTITY"] = 0] = "INTEGER_IDENTITY";
    MetaFieldType[MetaFieldType["INTEGER"] = 1] = "INTEGER";
    MetaFieldType[MetaFieldType["STRING"] = 2] = "STRING";
    MetaFieldType[MetaFieldType["MULTILINGUAL_STRING"] = 3] = "MULTILINGUAL_STRING";
    MetaFieldType[MetaFieldType["DATE"] = 4] = "DATE";
    MetaFieldType[MetaFieldType["DATE_TIME"] = 5] = "DATE_TIME";
    MetaFieldType[MetaFieldType["BOOLEAN"] = 6] = "BOOLEAN";
    MetaFieldType[MetaFieldType["CLASSIFIER"] = 7] = "CLASSIFIER";
    MetaFieldType[MetaFieldType["PARENT"] = 8] = "PARENT";
    MetaFieldType[MetaFieldType["MULTI_SELECT"] = 9] = "MULTI_SELECT";
    MetaFieldType[MetaFieldType["SUB_ENTITY"] = 10] = "SUB_ENTITY";
    MetaFieldType[MetaFieldType["MAIN_ENTITY"] = 11] = "MAIN_ENTITY";
    MetaFieldType[MetaFieldType["DECIMAL"] = 12] = "DECIMAL";
    MetaFieldType[MetaFieldType["BIG_DECIMAL"] = 13] = "BIG_DECIMAL";
    MetaFieldType[MetaFieldType["INTEGER_INSTANCE"] = 14] = "INTEGER_INSTANCE";
    MetaFieldType[MetaFieldType["DOCUMENT"] = 15] = "DOCUMENT";
    MetaFieldType[MetaFieldType["MULTILINESTRING"] = 16] = "MULTILINESTRING";
    MetaFieldType[MetaFieldType["WORKFLOW_STATE"] = 17] = "WORKFLOW_STATE";
    MetaFieldType[MetaFieldType["USER"] = 18] = "USER";
    MetaFieldType[MetaFieldType["LOCAL_DATE"] = 19] = "LOCAL_DATE";
    MetaFieldType[MetaFieldType["LOCAL_DATE_TIME"] = 20] = "LOCAL_DATE_TIME";
    MetaFieldType[MetaFieldType["MONEY"] = 21] = "MONEY";
    MetaFieldType[MetaFieldType["ACCOUNTING"] = 22] = "ACCOUNTING";
    MetaFieldType[MetaFieldType["LOOKUP"] = 23] = "LOOKUP";
})(MetaFieldType = exports.MetaFieldType || (exports.MetaFieldType = {}));
//TODO: I would suggest to separate MetaField and MetaFieldType in separate files.
//Also the types of the field and return types of the methods are not mentioned.
//The convention for model files is that "model" should be written in the file name e.g "meta-field.model.ts" MM
//# sourceMappingURL=meta-field.js.map